import { useContext } from 'react';

import { Link } from 'react-router-dom';

import { Button, Icons, ExternalLink, tokens } from '@cast/design-system';

import { CloseableAlert } from 'components/alerts';
import { HpaSettingsBanner } from 'features/cluster/workload-optimization/_components/HpaSettingsBanner';
import { isSystemPolicy } from 'features/cluster/workload-optimization/_utils';

import {
  makeEditScalingPolicySettingsLink,
  makeNewScalingPolicyLink,
} from '../../../../navigation';
import { WorkloadDetailsContext } from '../../../_context';

import { getDocsLink } from '@cast/utils';

const CustomBanner = ({ onClose }: { onClose: () => void }) => {
  const { workload } = useContext(WorkloadDetailsContext);

  const { id, isReadonly, isCastware } = workload?.verticalScalingPolicy || {};

  const isSysPolicy =
    workload?.verticalScalingPolicy &&
    isSystemPolicy(workload.verticalScalingPolicy);

  const bannerProps = isSysPolicy
    ? {
        title: 'Manage horizontal scaling via policy',
        description:
          'This workload uses Kubernetes HPA and is assigned to a system policy. Create or assign the workload to a custom policy to manage horizontal scaling in your scaling policy instead.',

        hexIcon: {
          Icon: <Icons.ArrowSquareOut weight="fill" />,
          size: 50,
          iconColor: tokens.theme.fg.status.onNeutralSubtle,
          hexColor: tokens.theme.bg.status.neutralSubtle,
        },
      }
    : {
        title: 'Manage horizontal scaling via policy',
        description:
          'This workload uses Kubernetes HPA. Manage horizontal scaling in your scaling policy instead.',
        hexIcon: {
          Icon: <Icons.CheckCircle weight="fill" />,
          size: 50,
          iconColor: tokens.theme.fg.status.onInfoSubtle,
          hexColor: tokens.theme.bg.status.infoSubtle,
        },
      };

  return (
    <HpaSettingsBanner
      testId="hpa-ownership-not-taken-banner"
      onClose={onClose}
      hexIcon={bannerProps.hexIcon}
      title={bannerProps.title}
      description={
        <>
          <span>{bannerProps.description} </span>
          <ExternalLink
            link={getDocsLink('docs_woop_hpa')}
            sx={{ typography: 'P12R' }}
          >
            Documentation
          </ExternalLink>
        </>
      }
      actionButtons={
        id && !isReadonly && !isCastware ? (
          <Button
            size="sm"
            component={Link}
            // todo:task should navigate to take ownership
            to={makeEditScalingPolicySettingsLink({
              policyId: id,
            })}
            testId="hpa-banner-configure-in-policy-button"
          >
            Enable in policy
          </Button>
        ) : isSysPolicy ? (
          <Button
            size="md"
            component={Link}
            variant="text"
            to={makeNewScalingPolicyLink()}
            testId="hpa-banner-configure-in-policy-button"
          >
            Go to scaling policies
          </Button>
        ) : undefined
      }
    />
  );
};
export const HpaOwnershipNotTakenBanner = () => {
  const { workload } = useContext(WorkloadDetailsContext);

  return (
    <CloseableAlert
      Component={CustomBanner}
      closeable={`hpa-ownership-taken-banner-${workload?.id}`}
    />
  );
};
